import React, { useEffect } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getPatientAppointments } from '../../redux/Appointment/AppointmentAction';
import { AppointmentItem, AppointmentHeader } from './AppointmentItem';
import { useParams } from 'react-router-dom';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Appointment/AppointmentType';

const styles = makeStyles({
    header: {
        color: '#8b8f92',
        borderBottom: '1px solid #efefef',
        display: 'flex'
    },
    item: {
        borderBottom: '1px solid #efefef',
        display: 'flex'
    },
    cell: {
        minWidth: '110px',
        padding: '12px 10px'
    },
    container: {
        // margin: '0 50px 0',
        paddingBottom: '23px',
        minHeight: 'calc(100% - 72px)'
    },
    timeCell: {
        minWidth: '110px',
        padding: '12px 10px',
        textAlign: 'center'
    },
    listContainer: {
        height: '100%',
        overflowY: 'visible'
    },
    loadingContainer: {
        height: 'calc(100vh - 200px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});
function AppointmentList() {
    const classes = styles();
    const params = useParams();
    const patientId = params?.id;
    const dispatch = useDispatch();
    const appointments = useSelector((state) => state.appointment?.appointment);
    const loadingSelector = createLoadingSelector(type.GET_PATIENT_APPOINTMENTS.REQUEST);
    const isLoading = useSelector(loadingSelector);

    useEffect(() => {
        dispatch(getPatientAppointments(null, patientId));
    }, [getPatientAppointments, patientId]);
    return isLoading ? (
        <div className={classes.loadingContainer}>
            <CircularProgress />
        </div>
    ) : appointments?.length ? (
        <div className={classes.container}>
            <AppointmentHeader />
            <div className={classes.listContainer}>
                {appointments?.map((appointment, key) => (
                    <AppointmentItem appointment={appointment} key={key} />
                ))}
            </div>
        </div>
    ) : null;
}
export default AppointmentList;
